// XXX: Top-8 L1/L2 category config. hard coded data source for now. will be replaced with a data source
// probably from searcholith in the future once the experiment has been validated and the data source is available.
import { messages } from './messages';
import { CategoryConfig, DEFAULT_L2_RESULT_COUNT } from './types';

const search = (query: string, iaCode?: string): string => {
  const iaCodeParam = iaCode ? `&iaCode=${iaCode}` : '';
  return `/shop?query=${encodeURIComponent(query)}${iaCodeParam}&ref=search_box`;
};

export const CATEGORY_CONFIG: CategoryConfig = {
  anime: {
    slug: 'anime',
    title: messages.animeTitle,
    attributiveTitle: messages.animeAttributiveTitle,
    l2Categories: [
      {
        slug: 'action-anime',
        title: messages.animeActionAnime,
        query: 'Action Anime',
        seeAllPath: search('Action Anime'),
        resultCount: DEFAULT_L2_RESULT_COUNT,
        active: true,
      },
      {
        slug: 'adventure-anime',
        title: messages.animeAdventureAnime,
        query: 'Adventure Anime',
        seeAllPath: search('Adventure Anime'),
        resultCount: DEFAULT_L2_RESULT_COUNT,
        active: true,
      },
      {
        slug: 'fantasy-anime',
        title: messages.animeFantasyAnime,
        query: 'Fantasy Anime',
        seeAllPath: search('Fantasy Anime'),
        resultCount: DEFAULT_L2_RESULT_COUNT,
        active: true,
      },
      {
        slug: 'sci-fi-anime',
        title: messages.animeSciFiAnime,
        query: 'Sci-Fi Anime',
        seeAllPath: search('Sci-Fi Anime'),
        resultCount: DEFAULT_L2_RESULT_COUNT,
        active: true,
      },
      {
        slug: 'romance-anime',
        title: messages.animeRomanceAnime,
        query: 'Romance Anime',
        seeAllPath: search('Romance Anime'),
        resultCount: DEFAULT_L2_RESULT_COUNT,
        active: true,
      },
      {
        slug: 'comedy-anime',
        title: messages.animeComedyAnime,
        query: 'Comedy Anime',
        seeAllPath: search('Comedy Anime'),
        resultCount: DEFAULT_L2_RESULT_COUNT,
        active: true,
      },
      {
        slug: 'sports-manga-and-anime',
        title: messages.animeSportsMangaAndAnime,
        query: 'sports manga and anime',
        seeAllPath: search('sports manga and anime'),
        resultCount: DEFAULT_L2_RESULT_COUNT,
        active: true,
      },
      {
        slug: 'horror-anime',
        title: messages.animeHorrorAnime,
        query: 'Horror Anime',
        seeAllPath: search('Horror Anime'),
        resultCount: DEFAULT_L2_RESULT_COUNT,
        active: true,
      },
      {
        slug: 'minimalist-anime',
        title: messages.animeMinimalistAnime,
        query: 'Minimalist Anime',
        seeAllPath: search('Minimalist Anime'),
        resultCount: DEFAULT_L2_RESULT_COUNT,
        active: false,
      },
      {
        slug: 'mystery-anime',
        title: messages.animeMysteryAnime,
        query: 'Mystery Anime',
        seeAllPath: search('Mystery Anime'),
        resultCount: DEFAULT_L2_RESULT_COUNT,
        active: false,
      },
    ],
  },
  music: {
    slug: 'music',
    title: messages.musicTitle,
    attributiveTitle: messages.musicAttributiveTitle,
    l2Categories: [
      {
        slug: 'rap-artist-music',
        title: messages.musicRapArtistMusic,
        query: 'rap artist music',
        seeAllPath: search('rap artist music'),
        resultCount: DEFAULT_L2_RESULT_COUNT,
        active: true,
      },
      {
        slug: '80s-punk-band',
        title: messages.music80sPunkBand,
        query: '80s punk band',
        seeAllPath: search('80s punk band'),
        resultCount: DEFAULT_L2_RESULT_COUNT,
        active: true,
      },
      {
        slug: '70s-rock-band',
        title: messages.music70sRockBand,
        query: '70s rock band',
        seeAllPath: search('70s rock band'),
        resultCount: DEFAULT_L2_RESULT_COUNT,
        active: true,
      },
      {
        slug: 'metal-band',
        title: messages.musicMetalBand,
        query: 'metal band',
        seeAllPath: search('metal band'),
        resultCount: DEFAULT_L2_RESULT_COUNT,
        active: true,
      },
      {
        slug: 'indie-music',
        title: messages.musicIndieMusic,
        query: 'Indie Music',
        seeAllPath: search('Indie Music'),
        resultCount: DEFAULT_L2_RESULT_COUNT,
        active: true,
      },
      {
        slug: 'musical-equipment',
        title: messages.musicMusicalEquipment,
        query: 'musical equipment guitars and meters and drums',
        seeAllPath: search('musical equipment guitars and meters and drums'),
        resultCount: DEFAULT_L2_RESULT_COUNT,
        active: true,
      },
      {
        slug: 'vinyl-record',
        title: messages.musicVinylRecord,
        query: 'vinyl record',
        seeAllPath: search('vinyl record'),
        resultCount: DEFAULT_L2_RESULT_COUNT,
        active: true,
      },
      {
        slug: 'glam-rock',
        title: messages.musicGlamRock,
        query: 'glam rock',
        seeAllPath: search('glam rock'),
        resultCount: DEFAULT_L2_RESULT_COUNT,
        active: true,
      },
      {
        slug: '80s-band',
        title: messages.music80sBand,
        query: '80s band',
        seeAllPath: search('80s band'),
        resultCount: DEFAULT_L2_RESULT_COUNT,
        active: false,
      },
      {
        slug: 'kpop',
        title: messages.musicKpop,
        query: 'kpop',
        seeAllPath: search('kpop'),
        resultCount: DEFAULT_L2_RESULT_COUNT,
        active: false,
      },
      {
        slug: 'garage-band',
        title: messages.musicGarageBand,
        query: 'garage band',
        seeAllPath: search('garage band'),
        resultCount: DEFAULT_L2_RESULT_COUNT,
        active: false,
      },
      {
        slug: 'edm',
        title: messages.musicEdm,
        query: 'edm',
        seeAllPath: search('edm'),
        resultCount: DEFAULT_L2_RESULT_COUNT,
        active: false,
      },
      {
        slug: 'bluegrass-band',
        title: messages.musicBluegrassBand,
        query: 'bluegrass band',
        seeAllPath: search('bluegrass band'),
        resultCount: DEFAULT_L2_RESULT_COUNT,
        active: false,
      },
      {
        slug: 'country-artist',
        title: messages.musicCountryArtist,
        query: 'country artist',
        seeAllPath: search('country artist'),
        resultCount: DEFAULT_L2_RESULT_COUNT,
        active: false,
      },
    ],
  },
  television: {
    slug: 'television',
    title: messages.televisionTitle,
    attributiveTitle: messages.televisionAttributiveTitle,
    l2Categories: [
      {
        slug: 'sitcom',
        title: messages.televisionSitcom,
        query: 'sitcom',
        seeAllPath: search('sitcom'),
        resultCount: DEFAULT_L2_RESULT_COUNT,
        active: true,
      },
      {
        slug: 'vintage-tv',
        title: messages.televisionVintageTv,
        query: 'vintage tv',
        seeAllPath: search('vintage tv'),
        resultCount: DEFAULT_L2_RESULT_COUNT,
        active: true,
      },
      {
        slug: 'classic-cartoons',
        title: messages.televisionClassicCartoons,
        query: 'classic cartoons',
        seeAllPath: search('classic cartoons'),
        resultCount: DEFAULT_L2_RESULT_COUNT,
        active: true,
      },
      {
        slug: 'sci-fi-tv',
        title: messages.televisionSciFiTv,
        query: 'sci-fi tv',
        seeAllPath: search('sci-fi tv'),
        resultCount: DEFAULT_L2_RESULT_COUNT,
        active: true,
      },
      {
        slug: 'uk-tv',
        title: messages.televisionUkTv,
        query: 'uk tv',
        seeAllPath: search('uk tv'),
        resultCount: DEFAULT_L2_RESULT_COUNT,
        active: true,
      },
      {
        slug: 'tv-nostalgia',
        title: messages.televisionTvNostalgia,
        query: 'TV Nostalgia',
        seeAllPath: search('TV Nostalgia'),
        resultCount: DEFAULT_L2_RESULT_COUNT,
        active: true,
      },
      {
        slug: 'witches-and-witchcraft-retro-tv',
        title: messages.televisionWitchesAndWitchcraftRetroTv,
        query: 'witches and witchcraft retro tv',
        seeAllPath: search('witches and witchcraft retro tv'),
        resultCount: DEFAULT_L2_RESULT_COUNT,
        active: true,
      },
      {
        slug: 'supernatural-creatures-and-demons',
        title: messages.televisionSupernaturalCreaturesAndDemons,
        query: 'supernatural creatures and demons',
        seeAllPath: search('supernatural creatures and demons'),
        resultCount: DEFAULT_L2_RESULT_COUNT,
        active: true,
      },
      {
        slug: 'mafia-and-law-tv',
        title: messages.televisionMafiaAndLawTv,
        query: 'mafia and law tv',
        seeAllPath: search('mafia and law tv'),
        resultCount: DEFAULT_L2_RESULT_COUNT,
        active: false,
      },
      {
        slug: 'teen-drama',
        title: messages.televisionTeenDrama,
        query: 'teen drama',
        seeAllPath: search('teen drama'),
        resultCount: DEFAULT_L2_RESULT_COUNT,
        active: false,
      },
      {
        slug: 'mystery-tv',
        title: messages.televisionMysteryTv,
        query: 'mystery tv',
        seeAllPath: search('mystery tv'),
        resultCount: DEFAULT_L2_RESULT_COUNT,
        active: false,
      },
      {
        slug: 'soap-opera',
        title: messages.televisionSoapOpera,
        query: 'soap opera',
        seeAllPath: '/shop/soap+opera+all-departments',
        resultCount: DEFAULT_L2_RESULT_COUNT,
        active: false,
      },
      {
        slug: 'reality-tv',
        title: messages.televisionRealityTv,
        query: 'reality tv',
        seeAllPath: '/shop/reality+tv+all-departments',
        resultCount: DEFAULT_L2_RESULT_COUNT,
        active: false,
      },
      {
        slug: 'kdrama',
        title: messages.televisionKdrama,
        query: 'kdrama',
        seeAllPath: search('kdrama'),
        resultCount: DEFAULT_L2_RESULT_COUNT,
        active: false,
      },
      {
        slug: 'cowboy-tv',
        title: messages.televisionCowboyTv,
        query: 'cowboy tv',
        seeAllPath: search('cowboy tv'),
        resultCount: DEFAULT_L2_RESULT_COUNT,
        active: false,
      },
      {
        slug: 'war-tv',
        title: messages.televisionWarTv,
        query: 'war tv',
        seeAllPath: search('war tv'),
        resultCount: DEFAULT_L2_RESULT_COUNT,
        active: false,
      },
    ],
  },
  movies: {
    slug: 'movies',
    title: messages.moviesTitle,
    attributiveTitle: messages.moviesAttributiveTitle,
    l2Categories: [
      {
        slug: 'classic-horror-movie',
        title: messages.moviesClassicHorrorMovie,
        query: 'classic horror movie',
        seeAllPath: search('classic horror movie'),
        resultCount: DEFAULT_L2_RESULT_COUNT,
        active: true,
      },
      {
        slug: '80s-movies',
        title: messages.movies80sMovies,
        query: '80s movies',
        seeAllPath: search('80s movies'),
        resultCount: DEFAULT_L2_RESULT_COUNT,
        active: true,
      },
      {
        slug: 'funny-movies',
        title: messages.moviesFunnyMovies,
        query: 'funny movies',
        seeAllPath: search('funny movies'),
        resultCount: DEFAULT_L2_RESULT_COUNT,
        active: true,
      },
      {
        slug: 'gangster-movies',
        title: messages.moviesGangsterMovies,
        query: 'gangster movies',
        seeAllPath: search('gangster movies'),
        resultCount: DEFAULT_L2_RESULT_COUNT,
        active: true,
      },
      {
        slug: 'war-movies',
        title: messages.moviesWarMovies,
        query: 'war movies',
        seeAllPath: search('war movies'),
        resultCount: DEFAULT_L2_RESULT_COUNT,
        active: true,
      },
      {
        slug: 'dune',
        title: messages.moviesDune,
        query: 'Dune',
        seeAllPath: '/shop/dune',
        resultCount: DEFAULT_L2_RESULT_COUNT,
        active: true,
      },
      {
        slug: 'sci-fi-movies',
        title: messages.moviesSciFiMovies,
        query: 'sci-fi movies',
        seeAllPath: search('sci-fi movies'),
        resultCount: DEFAULT_L2_RESULT_COUNT,
        active: true,
      },
      {
        slug: 'indie-and-cult-classic-movies',
        title: messages.moviesIndieAndCultClassicMovies,
        query: 'indie and cult classic movies',
        seeAllPath: search('indie and cult classic movies'),
        resultCount: DEFAULT_L2_RESULT_COUNT,
        active: true,
      },
      {
        slug: 'superhero-action-movies',
        title: messages.moviesSuperheroActionMovies,
        query: 'superhero action movies',
        seeAllPath: search('superhero action movies'),
        resultCount: DEFAULT_L2_RESULT_COUNT,
        active: false,
      },
      {
        slug: 'animation-movie',
        title: messages.moviesAnimationMovie,
        query: 'animation movie',
        seeAllPath: search('animation movie'),
        resultCount: DEFAULT_L2_RESULT_COUNT,
        active: false,
      },
      {
        slug: 'martial-arts-movies',
        title: messages.moviesMartialArtsMovies,
        query: 'martial arts movies',
        seeAllPath: search('martial arts movies'),
        resultCount: DEFAULT_L2_RESULT_COUNT,
        active: false,
      },
      {
        slug: 'psychological-thriller-movies',
        title: messages.moviesPsychologicalThrillerMovies,
        query: 'Psychological Thriller Movies',
        seeAllPath: search('Psychological Thriller Movies'),
        resultCount: DEFAULT_L2_RESULT_COUNT,
        active: false,
      },
      {
        slug: 'romcom',
        title: messages.moviesRomcom,
        query: 'romcom',
        seeAllPath: search('romcom'),
        resultCount: DEFAULT_L2_RESULT_COUNT,
        active: false,
      },
      {
        slug: 'western-movie',
        title: messages.moviesWesternMovie,
        query: 'western movie',
        seeAllPath: search('western movie'),
        resultCount: DEFAULT_L2_RESULT_COUNT,
        active: false,
      },
      {
        slug: 'pirate-movies',
        title: messages.moviesPirateMovies,
        query: 'pirate movies',
        seeAllPath: search('pirate movies'),
        resultCount: DEFAULT_L2_RESULT_COUNT,
        active: false,
      },
      {
        slug: 'musicals',
        title: messages.moviesMusicals,
        query: 'musicals',
        seeAllPath: '/shop/musicals',
        resultCount: DEFAULT_L2_RESULT_COUNT,
        active: false,
      },
    ],
  },
  animals: {
    slug: 'animals',
    title: messages.animalsTitle,
    attributiveTitle: messages.animalsAttributiveTitle,
    l2Categories: [
      {
        slug: 'dinosaurs',
        title: messages.animalsDinosaurs,
        query: 'dinosaurs',
        seeAllPath: search('dinosaurs'),
        resultCount: DEFAULT_L2_RESULT_COUNT,
        active: true,
      },
      {
        slug: 'bacteria-and-viruses',
        title: messages.animalsBacteriaAndViruses,
        query: 'bacteria and viruses',
        seeAllPath: search('bacteria and viruses'),
        resultCount: DEFAULT_L2_RESULT_COUNT,
        active: true,
      },
      {
        slug: 'snakes-turtles-and-lizards',
        title: messages.animalsSnakesTurtlesAndLizards,
        query: 'snakes turtles and lizards',
        seeAllPath: search('snakes turtles and lizards'),
        resultCount: DEFAULT_L2_RESULT_COUNT,
        active: true,
      },
      {
        slug: 'cats-and-kittens',
        title: messages.animalsCatsAndKittens,
        query: 'cats and kittens',
        seeAllPath: search('cats and kittens'),
        resultCount: DEFAULT_L2_RESULT_COUNT,
        active: true,
      },
      {
        slug: 'frogs',
        title: messages.animalsFrogs,
        query: 'frogs',
        seeAllPath: search('frogs'),
        resultCount: DEFAULT_L2_RESULT_COUNT,
        active: true,
      },
      {
        slug: 'axolotls',
        title: messages.animalsAxolotls,
        query: 'axolotls',
        seeAllPath: search('axolotls'),
        resultCount: DEFAULT_L2_RESULT_COUNT,
        active: true,
      },
      {
        slug: 'birds',
        title: messages.animalsBirds,
        query: 'birds',
        seeAllPath: search('birds'),
        resultCount: DEFAULT_L2_RESULT_COUNT,
        active: true,
      },
      {
        slug: 'dogs',
        title: messages.animalsDogs,
        query: 'dogs',
        seeAllPath: search('dogs'),
        resultCount: DEFAULT_L2_RESULT_COUNT,
        active: true,
      },
      // NOTE: `query`/`seeAllPath` preserve the product-approved spelling ("opposum") so results match the validated link.
      {
        slug: 'opossum',
        title: messages.animalsOpossum,
        query: 'opposum',
        seeAllPath: search('opposum'),
        resultCount: DEFAULT_L2_RESULT_COUNT,
        active: false,
      },
      {
        slug: 'otters',
        title: messages.animalsOtters,
        query: 'otters',
        seeAllPath: search('otters'),
        resultCount: DEFAULT_L2_RESULT_COUNT,
        active: false,
      },
      {
        slug: 'raccoon',
        title: messages.animalsRaccoon,
        query: 'raccoon',
        seeAllPath: search('raccoon'),
        resultCount: DEFAULT_L2_RESULT_COUNT,
        active: false,
      },
      {
        slug: 'sloth',
        title: messages.animalsSloth,
        query: 'sloth',
        seeAllPath: search('sloth'),
        resultCount: DEFAULT_L2_RESULT_COUNT,
        active: false,
      },
      {
        slug: 'butterfly',
        title: messages.animalsButterfly,
        query: 'butterfly',
        seeAllPath: search('butterfly'),
        resultCount: DEFAULT_L2_RESULT_COUNT,
        active: false,
      },
      {
        slug: 'caterpillar',
        title: messages.animalsCaterpillar,
        query: 'caterpillar',
        seeAllPath: search('caterpillar', 'all-departments'),
        resultCount: DEFAULT_L2_RESULT_COUNT,
        active: false,
      },
      {
        slug: 'bees',
        title: messages.animalsBees,
        query: 'bees',
        seeAllPath: search('bees'),
        resultCount: DEFAULT_L2_RESULT_COUNT,
        active: false,
      },
      {
        slug: 'lady-bug',
        title: messages.animalsLadyBug,
        query: 'lady bug',
        seeAllPath: search('lady bug'),
        resultCount: DEFAULT_L2_RESULT_COUNT,
        active: false,
      },
    ],
  },
  gaming: {
    slug: 'gaming',
    title: messages.gamingTitle,
    attributiveTitle: messages.gamingAttributiveTitle,
    l2Categories: [
      {
        slug: 'roleplaying',
        title: messages.gamingRoleplaying,
        query: 'roleplaying',
        seeAllPath: search('roleplaying'),
        resultCount: DEFAULT_L2_RESULT_COUNT,
        active: true,
      },
      {
        slug: 'battle-royale',
        title: messages.gamingBattleRoyale,
        query: 'battle royale',
        seeAllPath: search('battle royale'),
        resultCount: DEFAULT_L2_RESULT_COUNT,
        active: true,
      },
      {
        slug: 'fps',
        title: messages.gamingFps,
        query: 'fps game',
        seeAllPath: search('fps game'),
        resultCount: DEFAULT_L2_RESULT_COUNT,
        active: true,
      },
      {
        slug: 'gamer',
        title: messages.gamingGamer,
        query: 'gamer',
        seeAllPath: search('gamer'),
        resultCount: DEFAULT_L2_RESULT_COUNT,
        active: true,
      },
      {
        slug: 'video-games',
        title: messages.gamingVideoGames,
        query: 'video games',
        seeAllPath: search('video games', 'all-departments'),
        resultCount: DEFAULT_L2_RESULT_COUNT,
        active: true,
      },
      {
        slug: 'arcade',
        title: messages.gamingArcade,
        query: 'arcade',
        seeAllPath: search('arcade'),
        resultCount: DEFAULT_L2_RESULT_COUNT,
        active: true,
      },
      {
        slug: 'zombie-gaming',
        title: messages.gamingZombieGaming,
        query: 'zombie gaming',
        seeAllPath: search('zombie gaming'),
        resultCount: DEFAULT_L2_RESULT_COUNT,
        active: true,
      },
      {
        slug: 'skull-gaming',
        title: messages.gamingSkullGaming,
        query: 'skull gaming',
        seeAllPath: search('skull gaming'),
        resultCount: DEFAULT_L2_RESULT_COUNT,
        active: true,
      },
      {
        slug: 'board-game',
        title: messages.gamingBoardGame,
        query: 'board game',
        seeAllPath: search('board game'),
        resultCount: DEFAULT_L2_RESULT_COUNT,
        active: false,
      },
      {
        slug: 'racing-game',
        title: messages.gamingRacingGame,
        query: 'racing game',
        seeAllPath: search('racing game'),
        resultCount: DEFAULT_L2_RESULT_COUNT,
        active: false,
      },
      {
        slug: 'game-controller',
        title: messages.gamingGameController,
        query: 'game controller',
        seeAllPath: search('game controller'),
        resultCount: DEFAULT_L2_RESULT_COUNT,
        active: false,
      },
      {
        slug: 'chess',
        title: messages.gamingChess,
        query: 'chess',
        seeAllPath: search('chess'),
        resultCount: DEFAULT_L2_RESULT_COUNT,
        active: false,
      },
      {
        slug: 'solitaire-poker-blackjack-bridge',
        title: messages.gamingSolitairePokerBlackjackBridge,
        query: 'Solitaire Poker Blackjack Bridge',
        seeAllPath: search('Solitaire Poker Blackjack Bridge'),
        resultCount: DEFAULT_L2_RESULT_COUNT,
        active: false,
      },
    ],
  },
  sports: {
    slug: 'sports',
    title: messages.sportsTitle,
    attributiveTitle: messages.sportsAttributiveTitle,
    l2Categories: [
      {
        slug: 'football',
        title: messages.sportsFootball,
        query: 'football',
        seeAllPath: search('football'),
        resultCount: DEFAULT_L2_RESULT_COUNT,
        active: true,
      },
      {
        slug: 'rugby',
        title: messages.sportsRugby,
        query: 'rugby',
        seeAllPath: search('rugby'),
        resultCount: DEFAULT_L2_RESULT_COUNT,
        active: true,
      },
      {
        slug: 'hockey',
        title: messages.sportsHockey,
        query: 'hockey',
        seeAllPath: search('hockey'),
        resultCount: DEFAULT_L2_RESULT_COUNT,
        active: true,
      },
      {
        slug: 'baseball',
        title: messages.sportsBaseball,
        query: 'baseball',
        seeAllPath: search('baseball'),
        resultCount: DEFAULT_L2_RESULT_COUNT,
        active: true,
      },
      {
        slug: 'basketball',
        title: messages.sportsBasketball,
        query: 'basketball',
        seeAllPath: search('basketball', 'all-departments'),
        resultCount: DEFAULT_L2_RESULT_COUNT,
        active: true,
      },
      {
        slug: 'boxing',
        title: messages.sportsBoxing,
        query: 'boxing',
        seeAllPath: search('boxing'),
        resultCount: DEFAULT_L2_RESULT_COUNT,
        active: true,
      },
      {
        slug: 'mixed-martial-arts-and-fighting',
        title: messages.sportsMixedMartialArtsAndFighting,
        query: 'mixed martial arts and fighting',
        seeAllPath: search('mixed martial arts and fighting'),
        resultCount: DEFAULT_L2_RESULT_COUNT,
        active: true,
      },
      {
        slug: 'cycling',
        title: messages.sportsCycling,
        query: 'cycling',
        seeAllPath: search('cycling'),
        resultCount: DEFAULT_L2_RESULT_COUNT,
        active: true,
      },
      {
        slug: 'skiing',
        title: messages.sportsSkiing,
        query: 'skiing',
        seeAllPath: search('skiing'),
        resultCount: DEFAULT_L2_RESULT_COUNT,
        active: false,
      },
      {
        slug: 'golf',
        title: messages.sportsGolf,
        query: 'golf',
        seeAllPath: search('golf'),
        resultCount: DEFAULT_L2_RESULT_COUNT,
        active: false,
      },
      {
        slug: 'tennis',
        title: messages.sportsTennis,
        query: 'tennis',
        seeAllPath: search('tennis'),
        resultCount: DEFAULT_L2_RESULT_COUNT,
        active: false,
      },
      {
        slug: 'australian-rules-football',
        title: messages.sportsAustralianRulesFootball,
        query: 'Australian rules football',
        seeAllPath: search('Australian rules football'),
        resultCount: DEFAULT_L2_RESULT_COUNT,
        active: false,
      },
      {
        slug: 'surfing',
        title: messages.sportsSurfing,
        query: 'surfing',
        seeAllPath: search('surfing'),
        resultCount: DEFAULT_L2_RESULT_COUNT,
        active: false,
      },
      {
        slug: 'gym-weightlifting-and-working-out',
        title: messages.sportsGymWeightliftingAndWorkingOut,
        query: 'gym weightlifting and working out',
        seeAllPath: search('gym weightlifting and working out'),
        resultCount: DEFAULT_L2_RESULT_COUNT,
        active: false,
      },
      {
        slug: 'cricket',
        title: messages.sportsCricket,
        query: 'cricket',
        seeAllPath: search('cricket'),
        resultCount: DEFAULT_L2_RESULT_COUNT,
        active: false,
      },
    ],
  },
  books: {
    slug: 'books',
    title: messages.booksTitle,
    attributiveTitle: messages.booksAttributiveTitle,
    l2Categories: [
      {
        slug: 'childrens-books',
        title: messages.booksChildrensBooks,
        query: 'childrens books',
        seeAllPath: search('childrens books'),
        resultCount: DEFAULT_L2_RESULT_COUNT,
        active: true,
      },
      {
        slug: 'mystery-book',
        title: messages.booksMysteryBook,
        query: 'mystery book',
        seeAllPath: search('mystery book'),
        resultCount: DEFAULT_L2_RESULT_COUNT,
        active: true,
      },
      {
        slug: 'comic-book',
        title: messages.booksComicBook,
        query: 'comic book',
        seeAllPath: search('comic book'),
        resultCount: DEFAULT_L2_RESULT_COUNT,
        active: true,
      },
      {
        slug: 'literary-classics',
        title: messages.booksLiteraryClassics,
        query: 'literary classics',
        seeAllPath: search('literary classics'),
        resultCount: DEFAULT_L2_RESULT_COUNT,
        active: true,
      },
      {
        slug: 'poetry',
        title: messages.booksPoetry,
        query: 'poetry',
        seeAllPath: search('poetry'),
        resultCount: DEFAULT_L2_RESULT_COUNT,
        active: true,
      },
      {
        slug: 'dystopian-fiction',
        title: messages.booksDystopianFiction,
        query: 'dystopian fiction',
        seeAllPath: search('dystopian fiction'),
        resultCount: DEFAULT_L2_RESULT_COUNT,
        active: true,
      },
      {
        slug: 'scifi-book',
        title: messages.booksScifiBook,
        query: 'scifi book',
        seeAllPath: search('scifi book'),
        resultCount: DEFAULT_L2_RESULT_COUNT,
        active: true,
      },
      {
        slug: 'wizard-and-fantasy-books',
        title: messages.booksWizardAndFantasyBooks,
        query: 'wizard and fantasy books',
        seeAllPath: search('wizard and fantasy books'),
        resultCount: DEFAULT_L2_RESULT_COUNT,
        active: true,
      },
      {
        slug: 'book-quote',
        title: messages.booksBookQuote,
        query: 'book quote',
        seeAllPath: search('book quote'),
        resultCount: DEFAULT_L2_RESULT_COUNT,
        active: false,
      },
      {
        slug: 'magazine-cover',
        title: messages.booksMagazineCover,
        query: 'magazine cover',
        seeAllPath: search('magazine cover'),
        resultCount: DEFAULT_L2_RESULT_COUNT,
        active: false,
      },
      {
        slug: 'horror-book',
        title: messages.booksHorrorBook,
        query: 'horror book',
        seeAllPath: search('horror book'),
        resultCount: DEFAULT_L2_RESULT_COUNT,
        active: false,
      },
      {
        slug: 'fairy-tales',
        title: messages.booksFairyTales,
        query: 'fairy tales',
        seeAllPath: search('fairy tales'),
        resultCount: DEFAULT_L2_RESULT_COUNT,
        active: false,
      },
      {
        slug: 'book-lover',
        title: messages.booksBookLover,
        query: 'book lover',
        seeAllPath: search('book lover'),
        resultCount: DEFAULT_L2_RESULT_COUNT,
        active: false,
      },
      {
        slug: 'philosophy',
        title: messages.booksPhilosophy,
        query: 'philosophy',
        seeAllPath: search('philosophy'),
        resultCount: DEFAULT_L2_RESULT_COUNT,
        active: false,
      },
      {
        slug: 'mythology',
        title: messages.booksMythology,
        query: 'mythology',
        seeAllPath: search('mythology'),
        resultCount: DEFAULT_L2_RESULT_COUNT,
        active: false,
      },
      {
        slug: 'writers-and-novelists',
        title: messages.booksWritersAndNovelists,
        query: 'writers and novelists',
        seeAllPath: search('writers and novelists'),
        resultCount: DEFAULT_L2_RESULT_COUNT,
        active: false,
      },
    ],
  },
  funny: {
    slug: 'funny',
    title: messages.funnyTitle,
    attributiveTitle: messages.funnyAttributiveTitle,
    l2Categories: [
      {
        slug: 'memes',
        title: messages.funnyMemes,
        query: 'memes',
        seeAllPath: search('memes'),
        resultCount: DEFAULT_L2_RESULT_COUNT,
        active: true,
      },
      {
        slug: 'parody',
        title: messages.funnyParody,
        query: 'parody',
        seeAllPath: search('parody'),
        resultCount: DEFAULT_L2_RESULT_COUNT,
        active: true,
      },
      {
        slug: 'sarcasm',
        title: messages.funnySarcasm,
        query: 'Sarcasm',
        seeAllPath: search('Sarcasm'),
        resultCount: DEFAULT_L2_RESULT_COUNT,
        active: true,
      },
      {
        slug: 'math-science-and-tech',
        title: messages.funnyMathScienceAndTech,
        query: 'math science and tech',
        seeAllPath: search('math science and tech'),
        resultCount: DEFAULT_L2_RESULT_COUNT,
        active: true,
      },
      {
        slug: 'funny-sayings',
        title: messages.funnyFunnySayings,
        query: 'Funny Sayings',
        seeAllPath: search('Funny Sayings'),
        resultCount: DEFAULT_L2_RESULT_COUNT,
        active: true,
      },
      {
        slug: 'offensive',
        title: messages.funnyOffensive,
        query: 'Offensive',
        seeAllPath: search('Offensive'),
        resultCount: DEFAULT_L2_RESULT_COUNT,
        active: true,
      },
      {
        slug: 'funny-animals',
        title: messages.funnyFunnyAnimals,
        query: 'Funny Animals',
        seeAllPath: search('Funny Animals'),
        resultCount: DEFAULT_L2_RESULT_COUNT,
        active: true,
      },
      {
        slug: 'parodies-and-mashups',
        title: messages.funnyParodiesAndMashups,
        query: 'Parodies and Mashups',
        seeAllPath: search('Parodies and Mashups'),
        resultCount: DEFAULT_L2_RESULT_COUNT,
        active: true,
      },
      {
        slug: 'puns',
        title: messages.funnyPuns,
        query: 'Puns',
        seeAllPath: search('Puns'),
        resultCount: DEFAULT_L2_RESULT_COUNT,
        active: false,
      },
      {
        slug: 'funny-tv-shows',
        title: messages.funnyFunnyTvShows,
        query: 'funny tv shows',
        seeAllPath: search('funny tv shows'),
        resultCount: DEFAULT_L2_RESULT_COUNT,
        active: false,
      },
      {
        slug: 'funny-movies',
        title: messages.funnyFunnyMovies,
        query: 'funny movies',
        seeAllPath: '/shop/funny+movies',
        resultCount: DEFAULT_L2_RESULT_COUNT,
        active: false,
      },
    ],
  },
};
